import { isNumber as f } from "./DataUtils.js";
function s(r, i, v) {
  if (v === "number" && i === !0 && Array.isArray(r)) {
    var e = r == null ? void 0 : r[0], u = r == null ? void 0 : r[1];
    if (e && u && f(e) && f(u))
      return !0;
  }
  return !1;
}
export {
  s as isDomainSpecifiedByUser
};
